import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import { useInternalAdmin } from 'hooks'

import styles from './OtaBuster.module.scss'

function OtaBusterAnalytics() {
  const isInternalAdmin = useInternalAdmin()

  if (!isInternalAdmin) {
    return (
      <div className={styles.accessDenied} data-testid="ota-buster-access-denied">
        Access denied. OTA Buster is available to internal admins only.
      </div>
    )
  }

  return (
    <div className={styles.page} data-testid="ota-buster-analytics">
      <CustomHeader title="OTA Buster" width={1120} />

      <div className={styles.wrapper}>
        <div className={styles.pageHero}>
          <h1 className={styles.pageTitle}>OTA Buster - Analytics</h1>
          <p className={styles.pageSubtitle}>
            Performance across the OTA guest journey, direct booking lift, and channel
            outcomes.
          </p>
        </div>

        <div className={styles.comingSoonPanel} role="status">
          Analytics dashboard is coming soon. Use Guest Journey to configure stages and
          review step-level performance for now.
        </div>
      </div>
    </div>
  )
}

export default OtaBusterAnalytics
